'use client';

import { useSyncExternalStore } from 'react';
import {
  getCookiebotStatisticsConsent,
  hasExplicitlyDeclinedStatistics,
  subscribeToCookiebotConsent,
} from '@/lib/cookiebot';

export function useCookiebotStatisticsConsent(): boolean {
  return useSyncExternalStore(
    subscribeToCookiebotConsent,
    getCookiebotStatisticsConsent,
    () => false
  );
}

/**
 * Returns true only when the user has explicitly declined statistics cookies
 * via the Cookiebot banner. Returns false in all other cases (banner not
 * shown, not responded, or accepted).
 */
export function useCookiebotStatisticsDeclined(): boolean {
  return useSyncExternalStore(
    subscribeToCookiebotConsent,
    hasExplicitlyDeclinedStatistics,
    () => false
  );
}
